import http from './http'
import * as M from '@/mocks/index.js'

const mockApi = M && M.mockApi
const preferMock = String(process.env.VUE_APP_USE_MOCK) === 'true'
const hasMock = !!mockApi
const shouldFallback = e => hasMock && e && e.response && e.response.status === 404


// 绝对地址（/uploads 开头的静态链接）
export function absUrl(path) {
  const base = (process.env.VUE_APP_BASE_URL || '').replace(/\/$/, '')
  return `${base}${path}`
}

export async function listAttachments(personId) {
  if (preferMock && hasMock) return mockApi.listAttachments(personId)
  try { return await http.get(`/person/${personId}/attachments`) }
  catch (e) { if (shouldFallback(e)) return mockApi.listAttachments(personId); throw e }
}

export async function uploadAttachment(personId, file) {
  if (preferMock && hasMock) return mockApi.uploadAttachment(personId, file)
  const form = new FormData(); form.append('file', file)
  try { return await http.post(`/person/${personId}/attachments`, form) }
  catch (e) { if (shouldFallback(e)) return mockApi.uploadAttachment(personId, file); throw e }
}

export async function deleteAttachment(personId, attId) {
  if (preferMock && hasMock) return mockApi.deleteAttachment(personId, attId)
  try { return await http.delete(`/person/${personId}/attachments/${attId}`) }
  catch (e) { if (shouldFallback(e)) return mockApi.deleteAttachment(personId, attId); throw e }
}

// 下载直链（带 Content-Disposition 的接口）
export function downloadAttachmentUrl(personId, attId) {
  const base = (process.env.VUE_APP_BASE_URL || '').replace(/\/$/, '')
  return `${base}/person/${personId}/attachments/${attId}/download`
}
export async function listPersons(params) {
  if (preferMock && hasMock) return mockApi.listPersons(params)
  try { return await http.get('/person', { params }) }
  catch (e) { if (shouldFallback(e)) return mockApi.listPersons(params); throw e }
}

export async function getPerson(id) {
  if (preferMock && hasMock) return mockApi.getPerson(id)
  try { return await http.get(`/person/${id}`) }
  catch (e) { if (shouldFallback(e)) return mockApi.getPerson(id); throw e }
}

export async function createPerson(payload) {
  if (preferMock && hasMock) return mockApi.createPerson(payload)
  try { return await http.post('/person', payload) }
  catch (e) { if (shouldFallback(e)) return mockApi.createPerson(payload); throw e }
}

// 只保留这一份 updatePerson
export async function updatePerson(id, payload) {
  if (preferMock && hasMock) return mockApi.updatePerson(id, payload)
  try { return await http.put(`/person/${id}`, payload) } // baseURL 已含 /api
  catch (e) { if (shouldFallback(e)) return mockApi.updatePerson(id, payload); throw e }
}

// export async function setLeave(id, date) {
//   if (preferMock && hasMock) return mockApi.setLeave(id, date)
//   try { return await http.put(`/person/${id}/leave`, { date }) }
//   catch (e) { if (shouldFallback(e)) return mockApi.setLeave(id, date); throw e }
// }

export function exportRoster(params) {
  if (preferMock && hasMock) {
    const blob = new Blob(['Mock Excel'], { type: 'application/vnd.ms-excel' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob); a.download = '花名册.xlsx'; a.click()
    URL.revokeObjectURL(a.href)
    return Promise.resolve()
  }
  const base = (process.env.VUE_APP_BASE_URL || '').replace(/\/$/, '')
  const url = new URL(`${base}/person/export`, window.location.origin)
  Object.entries(params || {}).forEach(([k, v]) => v != null && url.searchParams.append(k, v))
  window.open(url.toString())
  return Promise.resolve()
}

export async function importPersons(file, { onlyCheck = false, updateExisting = true } = {}) {
  const form = new FormData()
  form.append('file', file)
  // 通过 querystring 把两个开关传给后端
  return http.post('/person/import', form, {
    params: {
      validateOnly: onlyCheck,
      updateExisting
    }
  })
}
// export function setLeave(id, date, reason = '') {
//   return request.post(`/person/${id}/leave`, null, { params: { date, reason } })
// }

export function setLeave(id, date, reason) {
  return http.put(`/person/${id}/leave`, { date, reason });
}


export async function listChangeLogs(personId) {
  if (preferMock && hasMock) return mockApi.listChangeLogs(personId)
  try { return await http.get(`/person/${personId}/changes`) }
  catch (e) { if (shouldFallback(e)) return mockApi.listChangeLogs(personId); throw e }
}
// export async function getPersonStats(params) {
//   return await http.get('/person/stats/all', { params })
// }
export function getPersonStats() {
  return http.get('/person/stats')
}

// ========================
// ✅ 删除人员接口（修正版）
// ========================
export async function deletePerson(id) {
  if (preferMock && hasMock) return mockApi.deletePerson(id)
  try {
    // 对应后端路由：@router.delete("/del/{person_id}")
    return await http.delete(`/person/del/${id}`)
  } catch (e) {
    if (shouldFallback(e)) return mockApi.deletePerson(id)
    throw e
  }
}

// ========================
// 🔽 新增：上传压缩包接口
// ========================
export async function uploadArchive(personId, file) {
  if (preferMock && hasMock) return mockApi.uploadAttachment(personId, file)
  const form = new FormData(); form.append('file', file)
  try { return await http.post(`/person/${personId}/upload-archive`, form) }
  catch (e) { if (shouldFallback(e)) return mockApi.uploadAttachment(personId, file); throw e }
}

// ========================
// 🔽 新增：获取压缩包列表接口
// ========================
export async function listZipAttachments(personId) {
  if (preferMock && hasMock) return mockApi.listAttachments(personId)
  try { return await http.get(`/person/${personId}/archives`) }
  catch (e) { if (shouldFallback(e)) return mockApi.listAttachments(personId); throw e }
}

export async function deleteArchive(personId, attId) {
  if (preferMock && hasMock) return mockApi.deleteAttachment(personId, attId)
  try {
    // 对应后端路由：@router.delete("/{pid}/archives/{aid}")
    return await http.delete(`/person/${personId}/archives/${attId}`)
  } catch (e) {
    if (shouldFallback(e)) return mockApi.deleteAttachment(personId, attId)
    throw e
  }
}
